/* eslint-disable no-use-before-define */

const AccumulateButton = ({setModalOpen}) => {
  
  return (
    <button className="btn line" onClick={()=> setModalOpen(true)}>헤딩머니 적립하기</button>
  );
};

export default AccumulateButton;